import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from '@kyruus/intl';

import { Box } from '@biome-design-system/ui/Box';
import { Tooltip } from '@biome-design-system/ui/Tooltip';
import { Button } from '@biome-design-system/ui/Button';
import { ArrowBackIcon } from '@biome-design-system/icons/ArrowBackIcon';
import { TuneIcon } from '@biome-design-system/icons/TuneIcon';

import { messages } from '../lib/messages';
import {
  PROVIDER_DRAWER_OPEN,
  SORT_AND_FILTER_DRAWER_OPEN
} from '../../machines/map-search/map-search-states';
import { OPEN_SORT_AND_FILTER } from '../../machines/map-search/map-search-actions';
import {
  OPEN_MAPS_FILTER_DRAWER,
  CLICK_BACK_TO_LIST_VIEW_BUTTON
} from '../lib/constants';

export const MapControls = ({
  log,
  backToSearchUrl,
  state,
  send,
  filtersEnabled,
  onFiltersOpened
}) => {
  const history = useHistory();
  const intl = useIntl();

  const onOpenFilters = () => {
    log(OPEN_MAPS_FILTER_DRAWER);
    send({ type: OPEN_SORT_AND_FILTER });
    onFiltersOpened();
  };

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={2}
      justifyContent="flex-end"
      left={0}
      mx={2}
      position="absolute"
      top={16}
      zIndex={2}
    >
      {backToSearchUrl && (
        <Button
          href={backToSearchUrl}
          variant="outlined"
          size="small"
          startIcon={<ArrowBackIcon />}
          data-testid="BackToListView"
          onClick={(e) => {
            e.preventDefault();
            log(CLICK_BACK_TO_LIST_VIEW_BUTTON);
            history.push(backToSearchUrl);
          }}
        >
          {intl.formatMessage(messages.backToListView)}
        </Button>
      )}
      {!state.matches(PROVIDER_DRAWER_OPEN) && (
        <Tooltip
          title={
            filtersEnabled === false
              ? intl.formatMessage(messages.noFilterOptions)
              : ''
          }
        >
          <Button
            variant="outlined"
            size="small"
            endIcon={<TuneIcon />}
            data-testid="MapViewFilterButton"
            disabled={
              filtersEnabled === false ||
              state.matches(SORT_AND_FILTER_DRAWER_OPEN)
            }
            onClick={onOpenFilters}
            // keep the tooltip hoverable even when the button is disabled
            // by re-enabling pointer events on the button
            sx={
              filtersEnabled === false
                ? { '&.Mui-disabled': { pointerEvents: 'auto' } }
                : {}
            }
          >
            {intl.formatMessage(messages.filterBtn)}
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};
